exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ys-monitor-wrapper .select-grid-item[data-v-439c99e3]{border:5px solid var(--systemMainColor)!important}.ys-monitor-wrapper .default-grid-item[data-v-439c99e3]{background:var(--collapseHeadHeaderBg);border:1px solid transparent}.ys-monitor-wrapper .bottom-btns[data-v-439c99e3]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ys-monitor-wrapper .bottom-btns .icon-item[data-v-439c99e3]{width:35px;margin-right:10px;cursor:pointer}", ""]);

// exports
